export const PARALLAX_GAP_HIDE_COOKIE = 'binaaz_parallax_gap_hidden';
export const PARALLAX_GAP_HIDE_MAX_AGE_SECONDS = 60 * 60;
export const PARALLAX_GAP_BANNER_CONTAINER_ID =
  'js-lotriver-parallax-gap-banner';
export const PARALLAX_GAP_BANNER_CONTAINER_ID_MOBILE =
  'js-lotriver-parallax-gap-banner-mobile';
export const PARALLAX_GAP_BANNER_SID = '220686';
export const PARALLAX_GAP_BANNER_BN = '23';
export const PARALLAX_GAP_BANNER_BN_MOBILE = '24';
export const PARALLAX_GAP_BANNER_AR_CN = 20;

export const PARALLAX_GAP_SLOT_HEIGHT_MOBILE_PX = 220;
export const PARALLAX_GAP_SLOT_HEIGHT_DESKTOP_PX = 500;
export const PARALLAX_GAP_SLOT_RADIUS_PX = 12;
export const PARALLAX_GAP_LIST_INDEX = 19;
export const PARALLAX_GAP_STICKY_VISIBLE_DESKTOP_PX = 70;
export const PARALLAX_GAP_STICKY_VISIBLE_MOBILE_PX = 54;
export const PARALLAX_GAP_STICKY_CONTENT_GAP_PX = 5;
export const PARALLAX_GAP_CLOSE_ICON_MOBILE_PX = 15;
export const PARALLAX_GAP_CLOSE_HIT_PADDING_MOBILE_PX = 15;
export const PARALLAX_GAP_CREATIVE_DETECT_MS = 6000;
export const PARALLAX_GAP_ATTACH_RAF_MAX = 900;
